<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / </label>
      <router-link to="/mecanico"> Cadastro/Mecanico </router-link>
      <label class="labelBar"> / </label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Ver</label>
    </div>
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col cols="12" sm="6">
            <v-text-field
              label="Nome *"
              v-model="nome"
              v-uppercase
              :counter="200"
              :rules="[(v) => !!v || 'O Nome é obrigatório']"
              :readonly="readOnly"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="cargoSelected"
              :items="filteredCargo"
              label="Cargo"
              item-text="descricao"
              item-value="id"
              persistent-hint
              return-object
              :rules="[(v) => !!v || 'O Cargo é obrigatório']"
              required
              :readonly="isAllowed"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="mecanico.ativo"
            @click.native.stop.prevent="checkAssociacao()"
            label="Ativo"
            :readonly="readOnly"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" class="text-right">
          <v-btn to="/mecanico" color="error" class="mr-4" v-if="!readOnly">
            Voltar
          </v-btn>
          <v-btn to="/mecanico" color="success" class="mr-4" v-else>
            Voltar
          </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4" v-if="!readOnly">
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { editarMecanicoAsync } from "../../../services/mecanicoService";
import { mapState, mapActions } from "vuex";
import TabNavegacao from "../../Tabs/TabCadastroUsuario";
import { getUserPermission } from "@/services/loginService";

export default {
  name: "editarMecanico",
  data: () => ({
    overlay: false,
    valid: true,
    nome: null,
    cargoSelected: null,
    readOnly: false,
  }),
  computed: {
    ...mapState("mecanico", ["mecanico"]),
    ...mapState("cargo", ["cargos"]),
    filteredCargo() {
      return this.cargos.filter((c) => {
        return c.ativo === true;
      });
    },
  },
  methods: {
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await editarMecanicoAsync(
          this.mecanico.id,
          this.nome,
          this.cargoSelected.id,
          this.mecanico.ativo
        );
        if (resposta) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Salvo com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/mecanico");
        }
      }
    },
    findCargo(cargoId) {
      return this.filteredCargo.find((cg) => cg.id === cargoId);
    },
  },
  created: function () {
    this.readOnly = !getUserPermission(1);
    this.nome = this.mecanico.nome;
    this.cargoSelected = this.findCargo(this.mecanico.idCargo);
  },
};
</script>